// /var/www/oszczedzam/client/src/pages/Settings.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function Settings() {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Ustawienia
      </Typography>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="body1">
          Tutaj pojawią się ustawienia konta.
        </Typography>
      </Paper>
    </Box>
  );
}

export default Settings;